import React from 'react'
import { CustomText } from 'src/components'
import { OffsetKeys } from 'src/core/models'
import { useAppSelector } from 'src/app/hooks'
import { offsetOptionalFieldsSelector } from 'src/features'

interface OffsetPreparedNameColumnProps {
  data: object,
  keys: OffsetKeys
}

const OffsetPreparedNameColumn: React.FC<OffsetPreparedNameColumnProps> = ({ data, keys }) => {
  const { use_company_name_in_offset } = useAppSelector(offsetOptionalFieldsSelector)

  const label = {
    NAME: `${data[keys?.nameField]} ${data[keys?.lastNameField]}`,
    COMPANY: data[keys?.companyNameField]
  }[use_company_name_in_offset ? 'COMPANY': 'NAME']

  return <CustomText label={label} />
}

export default OffsetPreparedNameColumn
